import { LmsButton } from '@shared/ui'

export function LegacySpeechRecoveryNotice({
  message,
  onRetry,
  onSkip,
}: {
  readonly message: string | null
  readonly onRetry: () => void
  readonly onSkip?: () => void
}) {
  if (!message) {
    return null
  }

  return (
    <div aria-live="polite" className="legacySelfStudySpeechRecovery" role="status">
      <span>{message}</span>
      <LmsButton onClick={onRetry} type="button" variant="outline">
        Try again
      </LmsButton>
      {onSkip ? (
        <LmsButton
          className="legacySelfStudySpeechRecoverySkip"
          onClick={onSkip}
          type="button"
          variant="accent"
        >
          Bỏ qua
        </LmsButton>
      ) : null}
    </div>
  )
}
